export * from './plusvaliaMinusvaliaSlice';
export * from './thunks';